import { render, staticRenderFns } from "./Collectors.vue?vue&type=template&id=7ea8e59b&scoped=true&"
import script from "./Collectors.vue?vue&type=script&lang=js&"
export * from "./Collectors.vue?vue&type=script&lang=js&"
import style0 from "./Collectors.vue?vue&type=style&index=0&id=7ea8e59b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea8e59b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
